import _ from "lodash";
import React from "react";
import {
  isAttachmentLocked,
  getAttachmentLockingState,
} from "Utils/AttachmentHelpers";
import {
  ENTITY_LOCKED_STATE,
  ENTITY_TO_BE_LOCKED_STATE,
} from "Constants/stringConstants";
import LockingTimerComponent from "../LockingTimerComponent";
import moment from "moment";
import {
  getAttachmentFragmentFromCache,
  writeAttachmentSimilarityReportInCache,
} from "modules/CommonGraphqlHelpers";
import { LockFilled } from "@toddle-edu/ds-icons";
import classes from "./LockingStateLabelComponent.scss";
import { useI18n } from "Hooks";
import { Tooltip } from "@toddle-edu/ds-web";
import classNames from "classnames";

const LockingStateLabelComponent = props => {
  const {
    attachment,
    lockedVariant = "",
    showDotSeparator = false,
    dsVersion,
  } = props;

  const { t } = useI18n(["common"]);

  const updateAttachmentLockingStateCache = ({
    attachment,
    updatedLockingState,
  }) => {
    const updatedAttachment = {
      ...attachment,
      lockingState: {
        ...attachment?.lockingState,
        ...updatedLockingState,
      },
    };

    writeAttachmentSimilarityReportInCache({
      attachmentId: attachment?.id,
      data: updatedAttachment,
    });
  };

  const onTimerStopCallback = () =>
    updateAttachmentLockingStateCache({
      attachment,
      updatedLockingState: {
        state: ENTITY_LOCKED_STATE,
        scheduledAt: moment(),
      },
    });

  const scheduledAt = _.get(attachment, "lockingState.scheduledAt", "");

  const dotSeparatorClasses = classNames({
    [classes.dotSeparator]: true,
    [classes.dotSeparatorV2]: dsVersion === "2.0",
  });

  return (
    <div className={classes.container}>
      {isAttachmentLocked({
        attachment: getAttachmentFragmentFromCache({
          attachmentId: attachment?.id,
        }),
      }) ? (
        <div className={classes.lockSubtext}>
          {showDotSeparator ? <div className={dotSeparatorClasses} /> : null}
          <Tooltip tooltip={t("common:locked")}>
            <LockFilled
              size={"xxxx-small"}
              variant={lockedVariant ? lockedVariant : "subtle"}
            />
          </Tooltip>
        </div>
      ) : null}

      {getAttachmentLockingState({
        attachment: getAttachmentFragmentFromCache({
          attachmentId: attachment?.id,
        }),
      }) === ENTITY_TO_BE_LOCKED_STATE ? (
        <div className={classes.lockSubtext}>
          {showDotSeparator ? <div className={dotSeparatorClasses} /> : null}
          <LockingTimerComponent
            scheduledAt={scheduledAt}
            onTimerStopCallback={onTimerStopCallback}
          />
        </div>
      ) : null}
    </div>
  );
};

export default LockingStateLabelComponent;
